export const styles = (theme) => ({
  tableContainer: {
    padding: 15,
  },
  tableWrapper: {
    maxHeight: 600,
    border: "1px solid #e0dcdc",
  },
  headerStyle: {
    padding: "0px",
    zIndex: "0",
    fontSize: "12px",
    backgroundColor: "rgb(112, 112, 113)",
    color: "white",
  },
  checkTablePagination: {
    margin: 20,
    float: "right",
    opacity: 0.5,
  },
  checkedBox: {
    "&&:hover": {
      backgroundColor: "transparent",
    },
  },
  actionIcons: {
    padding: 8,
    boxShadow: "none",
    "&&:hover": {
      backgroundColor: "transparent",
    },
  },
  switchBase: {
    color: "#E30613",
    "&$checked": {
      color: "#E30613",
    },
    "&$checked + $track": {
      backgroundColor: "#E30613",
    },
  },
  checked: {},
  track: {},
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  
});
